import { get } from 'lodash';
export var catchUserDeActivated = function (notification) { return get(notification, 'messages[0].json.status') === 'central-inactive-user'; };
//# sourceMappingURL=catchUserDeActivated.js.map